import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getKaiAssistantByUser } from '@api/kaiAssistants';

import { extractQueryParams } from '@utils/common';

import { IKaiAssistantDTO } from '@interfaces/kai/dto/kaiDTO';

import { GET_KAI_ASSISTANT_BY_USER } from '@constants/queryKeys';

export interface IKaiAssistantReturned {
	kaiAssistant?: IKaiAssistantDTO;
	isLoadingKaiAssistants: boolean;
}

export function useQueryKaiAssistantByUser(userId?: string, isKaiAssistantActive?: boolean): IKaiAssistantReturned {
	const { activeOrganisation } = useAppSelector(auth);

	const {
		data,
		isLoading,
	} = useQuery<IKaiAssistantDTO>({
		queryKey: [GET_KAI_ASSISTANT_BY_USER, { userId, organizationId: activeOrganisation }],
		queryFn: extractQueryParams(getKaiAssistantByUser),
		enabled: [!!userId, isKaiAssistantActive, !!activeOrganisation],
	});

	return {
		kaiAssistant: data,
		isLoadingKaiAssistants: isLoading,
	};
}
